<dx-box
    #workflowViewer
    *ngIf="!!workflowResult"
    width="100%"
    height="100%"
    direction="col"
    class="workflow-detail-box-container"
>
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <dx-form width="100%" height="100%" [colCount]="2">
                <dxi-item>
                    <dxo-label text="AAP Workflow #"></dxo-label>
                    <div *dxTemplate>
                        {{ workflowResult.workflowId }}
                    </div>
                </dxi-item>
                <dxi-item>
                    <div *dxTemplate>
                        <div class="right-container">
                            <dx-button
                                id="workflow-setting-button"
                                class="workflow-setting-button-content cc-dummy-button"
                                location="after"
                                hint="Settings"
                                type="default"
                                [tabIndex]="-1"
                            >
                                <div *dxTemplate="let data of 'content'">
                                    <div>
                                        <i title="Click to view settings" class="fas fa-cog"></i>
                                    </div>
                                    <dx-context-menu
                                        target="#workflow-setting-button"
                                        showEvent="dxclick"
                                        [position]="{ my: 'top center', at: 'bottom center' }"
                                        [items]="settingsMenu"
                                    ></dx-context-menu>
                                </div>
                            </dx-button>
                        </div>
                    </div>
                </dxi-item>
            </dx-form>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <app-workflow-job-details
                [workflowId]="workflowId"
                [communityId]="communityId"
                [hasNotes]="workflowResult?.hasNotes"
                [hasBoardNotes]="workflowResult?.hasBoardNotes"
                [hasVendorNotes]="workflowResult?.hasVendorNotes"
                [payee]="workflowResult?.payee"
                [payeeCode]="workflowResult?.payeeCode"
                [payeeType]="workflowResult?.payeeType"
                [managementCompanyVendorId]="workflowResult?.managementCompanyVendorId"
                [vendorAccountNumber]="workflowResult?.vendorAccountNumber"
                [pdfSource]="pdfSource"
                (onForceRefresh)="onForceRefresh()"
            ></app-workflow-job-details>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto">
        <div *dxTemplate>
            <app-workflow-invoice-header-details-viewer
                [workflowInfo]="workflowInfo"
                [communityId]="communityId"
            ></app-workflow-invoice-header-details-viewer>
        </div>
    </dxi-item>
    <dxi-item [ratio]="1">
        <div *dxTemplate>
            <app-workflow-invoice-line-items-viewer
                [lineItems]="workflowResult?.items"
                [entityUsesSubCategory]="workflowResult?.entityUsesSubCategory"
            ></app-workflow-invoice-line-items-viewer>
        </div>
    </dxi-item>
    <dxi-item baseSize="auto">
        <div *dxTemplate class="top-padding">
            <dx-toolbar width="100%">
                <dxi-item location="before">
                    <div *dxTemplate>
                        <dx-button
                            type="default"
                            text="Close"
                            [icon]="iconClose"
                            (onClick)="onViewerClose()"
                        ></dx-button>
                    </div>
                </dxi-item>
            </dx-toolbar>
        </div>
    </dxi-item>
</dx-box>

<cc-message-box #workflowDetailMessageBox></cc-message-box>

<dx-load-panel
    [position]="{ of: '#workflowViewer' }"
    *ngIf="loadingVisible"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
